import { useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { AccountDeletionModale } from '../components/Modal/AccountDeletionModale';
import { ProfileDeletionModale } from '../components/Modal/ProfileDeletionModale';
import { useWebsite } from '../hooks/useWebsite';

const messages = defineMessages({
  advancedOptions: { defaultMessage: 'Advanced options', id: '0cEOKu' },
  deleteWebsiteProfile: {
    defaultMessage: 'Delete my profile on {websiteName}',
    id: 'XD4LRd',
  },
  deleteGraphCommentAccount: {
    defaultMessage: 'Delete my GraphComment account',
    id: 'hV3tna',
  },
});

type AccountAdvancedOptionsProps = {
  onDeleteButtonClick: () => void;
};

export const AccountAdvancedOptions = ({ onDeleteButtonClick }: AccountAdvancedOptionsProps) => {
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const { name: websiteName } = useWebsite();

  return (
    <div className="m-2 w-full">
      <button
        type="button"
        className="flex items-center text-xs text-gray-500 hover:text-gray-700"
        onClick={() => setShowAdvancedOptions(prev => !prev)}
      >
        <span className="mr-1">
          <FormattedMessage {...messages.advancedOptions} />
        </span>
        <span
          className={`transform transition-transform ${showAdvancedOptions ? 'rotate-90' : ''}`}
        >
          ▸
        </span>
      </button>

      {showAdvancedOptions && (
        <div className="mt-2 flex flex-col gap-2">
          <ProfileDeletionModale
            poper={
              <button
                type="button"
                className="ml-2 text-xs underline hover:text-primary self-start"
              >
                <FormattedMessage {...messages.deleteWebsiteProfile} values={{ websiteName }} />
              </button>
            }
            onShowImmediate={onDeleteButtonClick}
          />

          <AccountDeletionModale
            poper={
              <button type="button" className="ml-2 text-xs text-primary underline self-start">
                <FormattedMessage {...messages.deleteGraphCommentAccount} />
              </button>
            }
            onShowImmediate={onDeleteButtonClick}
          />
        </div>
      )}
    </div>
  );
};
